import React, { useEffect, useState } from 'react';
import { Form, Button, Row, notification } from 'antd';
import Options from '../Options';
import UserStore from 'stores/UserStore';
import { FormErrorParser } from '@partsbadger/library';

interface IProps {
    contact_id: any;
}

interface IValues {
    requirement: any;
    value: any;
    files: any;
}

const Edit: React.FC<IProps> = ({ contact_id }) => {
    const [loading, setLoading] = useState(false);
    const [isSaved, setIsSaved] = useState(false);
    const [defaultValues, setDefaultValues] = useState<IValues[]>([]);

    const [form] = Form.useForm();

    const openNotification = () => {
        notification.success({
            message: 'Order Requirements Saved',
        });
    };

    useEffect(() => {
        async function getRequirements() {
            await UserStore.requirements()
                .then(data => {
                    const initialValue = data.results.map((item: IValues) => {
                        return {
                            requirement: item.requirement?.id,
                            value: item.value,
                            files: item.files,
                        };
                    });

                    form.setFieldsValue({
                        options: initialValue,
                    });
                })
                .catch(e => console.error(e));
        }

        getRequirements();
    }, [contact_id]);

    const handleSubmit = async () => {
        await form
            .validateFields()
            .then(async values => {
                const data = values.options
                    .filter((item: any) => item.requirement)
                    .map((item: any) => {
                        return {
                            requirement: item.requirement,
                            value: item.value,
                            files: item.files ? item.files.map((f: any) => f.id) : [],
                        };
                    });

                setIsSaved(false);

                UserStore.updateRequirements(data)
                    .then(() => {
                        setLoading(false);
                        openNotification();
                    })
                    .catch(() => {
                        setLoading(false);
                    });
            })
            .catch(errorInfo => {
                notification.error({
                    key: 'form-errors',
                    duration: 8,
                    message: 'Please input all required fields',
                    description: <FormErrorParser isAntd4 errors={errorInfo.errorFields} />,
                    placement: 'top',
                    maxCount: 1,
                });
            });

        setLoading(true);
    };

    return (
        <>
            <Form form={form} onFinish={handleSubmit}>
                <Form.Item name="options" initialValue={defaultValues} noStyle>
                    <Options
                        onChange={() => {
                            setIsSaved(false);
                        }}
                    />
                </Form.Item>
                <Row>
                    <Button
                        htmlType={'submit'}
                        loading={loading}
                        type="primary"
                        className="text-lg text-white font-bold"
                    >
                        Save
                    </Button>
                </Row>
            </Form>
        </>
    );
};

export default Edit;
